<template>
  <div class="maker-box">
    <!-- 标题 -->
    <van-nav-bar ref="navBar" id="navBar" fixed>
      <!-- 首页特殊处理 -->
      <template #left>
        <svg class="icon-logo" xmlns="http://www.w3.org/2000/svg" width="218" height="34" viewBox="0 0 218 34"
          fill="none">
          <g clip-path="url(#clip0_275_5142)">
            <path
              d="M16.4222 26.2524C16.4382 26.1548 16.4382 26.0553 16.4222 25.9578L15.2209 21.0275H8.86927L7.66796 25.9578C7.65198 26.0553 7.65198 26.1548 7.66796 26.2524C7.66796 26.5469 7.74464 26.6878 7.88522 26.6878H0C0.102239 26.6878 0.191699 26.5725 0.293938 26.342C0.34841 26.2169 0.395354 26.0886 0.434518 25.9578L8.10247 1.83126C8.12005 1.7468 8.12005 1.65961 8.10247 1.57514C8.14081 1.2806 8.06413 1.10132 7.92355 1.10132H16.3072C16.2049 1.10132 16.141 1.17815 16.1027 1.35744C16.0643 1.51303 16.0643 1.67567 16.1027 1.83126L23.7707 25.9578C23.8114 26.0898 23.8626 26.2183 23.924 26.342C24.0135 26.5725 24.1157 26.6878 24.218 26.6878H16.2049C16.3455 26.6878 16.4222 26.5469 16.4222 26.2524ZM13.8662 15.5337L12.0387 8.33672L10.2239 15.5337H13.8662Z"
              fill="#6937E3" />
            <path
              d="M41.9572 26.2524C41.9732 26.1548 41.9732 26.0553 41.9572 25.9578L40.7559 21.0275H34.4043L33.1263 25.9578C33.1103 26.0553 33.1103 26.1548 33.1263 26.2524C33.1263 26.5469 33.2029 26.6878 33.3563 26.6878H25.5605C25.65 26.6878 25.7522 26.5725 25.8417 26.342C25.9031 26.2183 25.9544 26.0898 25.9951 25.9578L33.663 1.83126C33.6806 1.7468 33.6806 1.65961 33.663 1.57514C33.663 1.25499 33.5991 1.10132 33.4458 1.10132H41.8422C41.7399 1.10132 41.676 1.17815 41.6377 1.35744C41.5993 1.51303 41.5993 1.67567 41.6377 1.83126L49.3057 25.9578C49.3448 26.0886 49.3918 26.2169 49.4462 26.342C49.5485 26.5725 49.6507 26.6878 49.7402 26.6878H41.7399C41.8933 26.6878 41.9572 26.5469 41.9572 26.2524ZM39.4012 15.5337L37.612 8.33672L35.7845 15.5337H39.4012Z"
              fill="#6937E3" />
            <path
              d="M67.503 26.2524C67.519 26.1548 67.519 26.0553 67.503 25.9578L66.3017 21.0275H59.9501L58.6721 25.9578C58.6561 26.0553 58.6561 26.1548 58.6721 26.2524C58.6721 26.5469 58.7488 26.6878 58.8893 26.6878H51.1191C51.2214 26.6878 51.3108 26.5725 51.4131 26.342C51.4745 26.2183 51.5257 26.0898 51.5664 25.9578L59.2344 1.83126C59.252 1.7468 59.252 1.65961 59.2344 1.57514C59.2344 1.25499 59.1577 1.10132 59.0171 1.10132H67.4008C67.3113 1.10132 67.2474 1.17815 67.2091 1.35744C67.164 1.51215 67.164 1.67655 67.2091 1.83126L74.877 25.9578C74.9092 26.0908 74.9564 26.2197 75.0176 26.342C75.1198 26.5725 75.2093 26.6878 75.3115 26.6878H67.2858C67.4263 26.6878 67.503 26.5469 67.503 26.2524ZM64.947 15.5337L63.1578 8.33672L61.3431 15.5337H64.947Z"
              fill="#6937E3" />
            <path
              d="M78.1106 25.9578V21.6038C78.1106 21.1684 78.1106 20.9507 77.9316 20.9507H83.8487C83.7465 20.9507 83.6954 21.1684 83.6954 21.6038V25.9578C83.6954 26.3932 83.7465 26.6109 83.8487 26.6109H77.9572C78.0594 26.6109 78.1106 26.3932 78.1106 25.9578Z"
              fill="#6937E3" />
            <path
              d="M87.5293 19.3755C87.6312 19.4799 87.7674 19.5436 87.9127 19.5548C88.283 19.577 88.6543 19.577 89.0246 19.5548C89.8933 19.5987 90.7557 19.3849 91.5039 18.9401C92.0709 18.5356 92.4816 17.9477 92.6668 17.2753C92.9303 16.1557 93.0421 15.0056 92.9991 13.8561V1.83126C92.9991 1.34463 92.9352 1.10132 92.8074 1.10132H100.105C99.9897 1.10132 99.9258 1.34463 99.9258 1.83126V17.1985C100.09 19.587 99.4755 21.9644 98.175 23.9729C97.6056 24.7353 96.8823 25.3688 96.0521 25.8322C95.2219 26.2956 94.3036 26.5784 93.357 26.6621C92.3601 26.7902 91.4911 26.8542 90.801 26.8799H88.8584C88.4175 26.8531 87.9772 26.9414 87.5804 27.136L87.5293 19.3755Z"
              fill="#6937E3" />
            <path
              d="M114.751 20.797C114.765 20.5732 114.725 20.3494 114.636 20.1439H121.895C121.808 20.2765 121.735 20.4182 121.678 20.5665C121.618 20.7749 121.583 20.9899 121.576 21.2068C121.519 22.091 121.259 22.95 120.815 23.7165C120.372 24.483 119.757 25.1362 119.02 25.6249C117.109 26.8151 114.875 27.3791 112.63 27.2384C111.31 27.3209 109.987 27.1292 108.744 26.6752C107.502 26.2213 106.366 25.5149 105.409 24.6004C104.533 23.6556 103.856 22.5442 103.417 21.3321C102.977 20.1201 102.786 18.832 102.853 17.5442C102.777 16.2602 102.955 14.9737 103.376 13.7586C103.797 12.5434 104.453 11.4233 105.307 10.4625C106.177 9.59387 107.219 8.91726 108.365 8.47617C109.512 8.03508 110.738 7.83927 111.965 7.90131C113.292 7.80173 114.625 7.97782 115.881 8.41854C117.136 8.85927 118.288 9.55513 119.262 10.4625C120.966 12.17 121.746 14.7312 121.601 18.1461V18.287C121.613 18.4259 121.638 18.5632 121.678 18.6968L121.78 18.9145H109.818C109.887 19.5501 110.037 20.1742 110.265 20.7714C110.426 21.2175 110.732 21.5964 111.134 21.8471C111.615 22.1092 112.159 22.2332 112.706 22.2056C113.213 22.229 113.717 22.1139 114.163 21.8727C114.325 21.7943 114.465 21.6753 114.568 21.5273C114.671 21.3792 114.734 21.2071 114.751 21.0275V20.797ZM110.7 13.203C110.284 13.7716 110.02 14.4372 109.933 15.1367H114.853C114.804 14.413 114.547 13.7191 114.112 13.139C113.885 12.9134 113.613 12.7394 113.313 12.6289C113.013 12.5184 112.693 12.474 112.374 12.4987C112.059 12.4728 111.742 12.5232 111.451 12.6458C111.16 12.7684 110.902 12.9595 110.7 13.203Z"
              fill="#6937E3" />
            <path
              d="M127.416 26.3164C127.434 26.1975 127.434 26.0767 127.416 25.9578L123.364 9.14352C123.316 8.93253 123.199 8.74352 123.032 8.60566C122.911 8.49791 122.759 8.43076 122.598 8.41357H130.764C130.623 8.41357 130.547 8.52883 130.547 8.77214V9.14352L131.71 20.9123L133.499 9.14352V8.77214C133.499 8.52883 133.422 8.41357 133.282 8.41357H140.208C140.068 8.41357 139.991 8.52883 139.991 8.77214V9.14352L141.819 20.9123L142.943 9.14352V8.77214C142.943 8.52883 142.943 8.41357 142.726 8.41357H150.905C150.74 8.43065 150.584 8.49764 150.458 8.60566C150.29 8.74066 150.177 8.93159 150.138 9.14352L146.125 25.9578C146.108 26.0767 146.108 26.1975 146.125 26.3164C146.125 26.5725 146.202 26.6878 146.343 26.6878H138.317C138.458 26.6878 138.534 26.5725 138.534 26.3164C138.552 26.1975 138.552 26.0767 138.534 25.9578L136.745 17.5059L134.956 25.9578C134.938 26.0767 134.938 26.1975 134.956 26.3164C134.956 26.5725 135.033 26.6878 135.186 26.6878H127.198C127.339 26.6878 127.416 26.5725 127.416 26.3164Z"
              fill="#6937E3" />
            <path
              d="M163.582 20.7971C163.596 20.5733 163.557 20.3495 163.467 20.144H170.726C170.634 20.2737 170.561 20.416 170.509 20.5666C170.444 20.7742 170.405 20.9894 170.394 21.2069C170.339 22.0898 170.08 22.9477 169.636 23.7125C169.192 24.4772 168.577 25.1277 167.838 25.6121C165.927 26.8024 163.694 27.3664 161.448 27.2257C160.126 27.3085 158.801 27.1169 157.557 26.663C156.312 26.209 155.174 25.5025 154.215 24.5877C153.342 23.6408 152.666 22.5291 152.228 21.3176C151.789 20.106 151.595 18.8189 151.659 17.5315C151.585 16.2466 151.765 14.9596 152.188 13.7444C152.611 12.5292 153.27 11.4096 154.125 10.4498C154.995 9.5805 156.037 8.90347 157.184 8.46233C158.33 8.0212 159.557 7.82575 160.784 7.88859C162.11 7.79056 163.443 7.96738 164.698 8.40802C165.954 8.84867 167.105 9.5437 168.081 10.4498C169.785 12.1573 170.565 14.7185 170.42 18.1334V18.2743C170.431 18.4131 170.457 18.5504 170.496 18.6841L170.599 18.9018H158.522C158.586 19.5368 158.732 20.1609 158.956 20.7586C159.121 21.2062 159.432 21.5851 159.838 21.8344C160.318 22.099 160.863 22.2232 161.41 22.1929C161.916 22.2131 162.419 22.0982 162.867 21.86C163.027 21.7787 163.164 21.659 163.267 21.5115C163.369 21.364 163.434 21.1933 163.455 21.0148L163.582 20.7971ZM159.531 13.2031C159.115 13.7717 158.851 14.4373 158.764 15.1368H163.582C163.533 14.4131 163.276 13.7192 162.841 13.1391C162.614 12.9135 162.342 12.7395 162.042 12.629C161.742 12.5185 161.422 12.4741 161.103 12.4988C160.794 12.4791 160.485 12.5326 160.201 12.655C159.917 12.7773 159.666 12.9651 159.467 13.2031H159.531Z"
              fill="#6937E3" />
            <path
              d="M173.551 25.9578V0.729944C173.551 0.243315 173.487 0 173.359 0H181.027C180.9 0 180.836 0.243315 180.836 0.729944V25.9578C180.836 26.4444 180.9 26.6878 181.027 26.6878H173.359C173.487 26.6878 173.551 26.4444 173.551 25.9578Z"
              fill="#6937E3" />
            <path
              d="M197.016 7.82446V13.5231C197.016 13.4079 196.773 13.3439 196.287 13.3439C195.358 13.296 194.429 13.4523 193.565 13.8018C192.702 14.1513 191.926 14.6856 191.29 15.3672V26.009C191.29 26.4956 191.29 26.739 191.469 26.739H184.172C184.3 26.739 184.364 26.4956 184.364 26.009V9.14348C184.364 8.65685 184.3 8.41354 184.172 8.41354H191.469C191.354 8.41354 191.29 8.65685 191.29 9.14348V10.8595C191.749 9.97192 192.438 9.22438 193.284 8.69527C194.206 8.20244 195.243 7.9638 196.287 8.00375C196.811 8.00375 197.016 7.93972 197.016 7.82446Z"
              fill="#6937E3" />
            <path
              d="M202.357 33.8208C202.411 33.7149 202.454 33.6032 202.484 33.4878C202.502 33.4126 202.527 33.3395 202.561 33.2701L204.823 25.817L199.277 9.16915C199.115 8.68252 198.859 8.43921 198.51 8.43921H207.123C206.97 8.43921 206.906 8.55446 206.906 8.79778V9.16915L208.299 18.1334L210.421 9.16915C210.431 9.04557 210.431 8.92136 210.421 8.79778C210.421 8.55446 210.357 8.43921 210.203 8.43921H217.948C217.599 8.43921 217.343 8.68252 217.181 9.16915L209.59 33.2957C209.574 33.3932 209.574 33.4927 209.59 33.5902C209.59 33.8848 209.679 34.0257 209.846 34.0257H202.178C202.216 34 202.293 33.936 202.357 33.8208Z"
              fill="#6937E3" />
          </g>
          <defs>
            <clipPath id="clip0_275_5142">
              <rect width="218" height="34" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </template>

      <template #right>
        <span class="search-box">search</span>
      </template>
    </van-nav-bar>

    <div class="top-tab-box">
      <span @click="toList('Rings')">Rings</span>
      <span @click="toList('Pendants')">Pendants</span>
      <span @click="toList('Chains')">Chains</span>
      <span @click="toList('Earrings')">Earrings</span>
      <span @click="toList('Necklaces')">Necklaces</span>
      <span @click="toList('Bracelets')">Bracelets</span>
      <span @click="toList('Anklets')">Anklets</span>
      <span @click="toList('Nose Studs')">Nose Studs</span>
      <span @click="toList('Sets')">Sets</span>
      <span @click="toList('Toe Rings')">Toe Rings</span>
      <span @click="toList('Clearance')">Clearance</span>
    </div>

    <img class="banner" @click="toList('Earrings')" src="https://xhdata.wan4.com/wsw-h5-60.png">

    <div class="min-banner-box">
      <img class="banner" @click="$router.push('/maker/customJewelry')" src="https://xhdata.wan4.com/wsw-h5-61.png">
      <img class="banner" @click="playVideo()" src="https://xhdata.wan4.com/wsw-h5-62.png">
    </div>

    <div class="class-box">
      <div @click="toList(item.title)" v-for="item, index in classList" :key="index">
        <div class="pic">
          <img v-lazy="`${item.img}?imageView2/1/w/198/h/198`">
        </div>
        <span>{{ item.title }}</span>
      </div>
    </div>

    <div class="new-product">
      <svg xmlns="http://www.w3.org/2000/svg" width="233" height="34" viewBox="0 0 233 34" fill="none">
        <g clip-path="url(#clip0_275_5817)">
          <path
            d="M0.317259 25.6886L4.71922 0.754426C4.79854 0.251507 4.78532 4.69667e-05 4.71922 4.69667e-05H12.2012C12.1821 -0.00263542 12.1625 -0.000590401 12.1443 0.00600445C12.1261 0.0125993 12.1098 0.0235446 12.0967 0.0378901C12.0837 0.0522356 12.0744 0.0695477 12.0696 0.0883231C12.0647 0.107098 12.0646 0.12677 12.069 0.145629L15.2813 16.3979L18.0309 0.754426C18.1234 0.251507 18.1102 4.69667e-05 18.0309 4.69667e-05H25.579C25.46 4.69667e-05 25.341 0.251507 25.2617 0.754426L20.8201 25.6886C20.7276 26.1916 20.7408 26.443 20.8201 26.443H13.3249L9.98043 11.5672L7.49523 25.6886C7.4027 26.1916 7.41592 26.443 7.49523 26.443H0C0.132191 26.4607 0.237944 26.2092 0.317259 25.6886Z"
            fill="white" />
          <path
            d="M37.0135 20.3682C37.068 20.142 37.068 19.9062 37.0135 19.68H44.522C44.403 19.8388 44.2973 19.9844 44.218 20.1167C44.1245 20.3305 44.0493 20.5519 43.9932 20.7785C43.7587 21.7275 43.339 22.6207 42.7582 23.4066C42.1774 24.1925 41.447 24.8556 40.6091 25.3577C38.5254 26.5377 36.1536 27.1107 33.7617 27.012C30.5494 27.012 28.2096 26.1121 26.7687 24.2989C26.0303 23.2536 25.5294 22.0591 25.301 20.7993C25.0727 19.5396 25.1224 18.245 25.4468 17.0066C25.8283 14.1887 27.1849 11.5941 29.2804 9.67454C31.3133 7.90283 33.9358 6.95839 36.6302 7.0276C39.9218 7.0276 42.288 7.92756 43.7024 9.67454C45.1169 11.4215 45.4606 14.1214 44.7203 17.6154V17.761C44.7064 17.9018 44.7064 18.0436 44.7203 18.1845L44.7996 18.4095H32.2943C32.2404 19.0553 32.276 19.7056 32.4001 20.3417C32.4848 20.7911 32.7408 21.1898 33.1139 21.4534C33.5881 21.7218 34.1302 21.846 34.6738 21.8108C35.2183 21.8266 35.7585 21.7084 36.2468 21.4667C36.4248 21.383 36.5837 21.2634 36.7133 21.1153C36.843 20.9673 36.9407 20.794 37.0003 20.6064L37.0135 20.3682ZM34.2508 12.5068C33.7056 13.0949 33.2951 13.7949 33.0478 14.5582H38.1372C38.2277 13.8479 38.0838 13.1275 37.7274 12.5068C37.5269 12.2662 37.2694 12.0796 36.9785 11.9641C36.6876 11.8485 36.3725 11.8076 36.0618 11.845C35.7311 11.829 35.4006 11.8793 35.0896 11.9929C34.7786 12.1066 34.4934 12.2813 34.2508 12.5068Z"
            fill="white" />
          <path
            d="M49.1482 26.0724C49.1649 25.945 49.1649 25.816 49.1482 25.6886L48.0774 8.31139C48.0788 8.20916 48.0583 8.10783 48.0173 8.01422C47.9762 7.92061 47.9156 7.83691 47.8395 7.76876C47.7351 7.64816 47.5884 7.57234 47.4297 7.55701H55.8767C55.7313 7.55701 55.6255 7.67612 55.5859 7.94081V8.31139L54.6473 20.4741L58.6131 8.31139L58.7188 7.94081C58.7188 7.67612 58.7188 7.55701 58.5602 7.55701H65.7249C65.5795 7.55701 65.4738 7.67612 65.4341 7.94081V8.31139L65.1697 20.4741L68.4877 8.31139L68.567 7.94081C68.567 7.67612 68.567 7.55701 68.4084 7.55701H76.8554C76.675 7.57727 76.5047 7.65101 76.3663 7.76876C76.1696 7.90147 76.0175 8.09062 75.9301 8.31139L68.7389 25.6886C68.6845 25.8104 68.6489 25.9398 68.6331 26.0724C68.6331 26.3238 68.6331 26.443 68.7918 26.443H60.4769C60.6224 26.443 60.7281 26.3238 60.7678 26.0724C60.7845 25.945 60.7845 25.816 60.7678 25.6886L60.4637 16.9669L57.0664 25.6886C57.0172 25.8122 56.9817 25.9409 56.9607 26.0724C56.9607 26.3238 56.9607 26.443 57.1325 26.443H48.9102C49.0028 26.4694 49.0953 26.3238 49.1482 26.0724Z"
            fill="white" />
          <path
            d="M107.827 22.0887C106.877 23.5556 105.584 24.7685 104.06 25.6224C102.642 26.4039 101.052 26.8179 99.4332 26.8268C98.2657 26.8462 97.1075 26.6161 96.0359 26.1518C95.5894 25.9789 95.1869 25.7087 94.8576 25.3608C94.5284 25.0128 94.2806 24.5959 94.1323 24.1401L92.5328 33.0868C92.4803 33.2429 92.4649 33.4092 92.4879 33.5723C92.5108 33.7354 92.5715 33.8909 92.665 34.0265H85.2227C85.4037 33.7972 85.518 33.5225 85.5531 33.2324L89.889 8.3114C89.9621 8.06526 89.9621 7.80316 89.889 7.55702H97.252C97.0914 7.78166 96.983 8.03941 96.9348 8.3114L96.6704 9.78045C97.3473 8.9906 98.1918 8.36209 99.1424 7.94083C100.309 7.41696 101.578 7.15928 102.857 7.18645C103.95 7.11585 105.045 7.29209 106.061 7.70214C107.077 8.11219 107.988 8.74557 108.726 9.55546C110.066 11.1436 110.458 13.4994 109.903 16.6228C109.602 18.5704 108.895 20.4328 107.827 22.0887ZM102.17 14.042C101.979 13.6669 101.684 13.355 101.321 13.1436C100.957 12.9323 100.54 12.8307 100.121 12.8509C99.6631 12.8584 99.2123 12.9625 98.7977 13.1563C98.3832 13.3502 98.0141 13.6294 97.7147 13.9759C96.9716 14.7715 96.4835 15.7718 96.3135 16.8478C96.0391 17.9799 96.127 19.1697 96.5647 20.2491C96.7388 20.6353 97.0246 20.9602 97.3852 21.182C97.7457 21.4038 98.1644 21.5122 98.5872 21.4932C99.0643 21.4873 99.5343 21.3763 99.9638 21.1682C100.393 20.96 100.772 20.6598 101.072 20.2888C101.842 19.3732 102.337 18.2582 102.5 17.0728C102.747 16.0549 102.63 14.9827 102.17 14.042Z"
            fill="white" />
          <path
            d="M127.472 6.94824L126.428 12.8509C126.428 12.7186 126.19 12.6524 125.714 12.6524C123.67 12.58 121.68 13.3171 120.175 14.7038L118.245 25.6886C118.153 26.1915 118.166 26.443 118.245 26.443H110.75C110.882 26.443 110.988 26.1915 111.067 25.6886L114.134 8.31142C114.227 7.8085 114.134 7.55704 114.134 7.55704H121.616C121.484 7.55704 121.378 7.8085 121.286 8.31142L120.982 10.0849C121.615 9.16536 122.452 8.40451 123.427 7.86144C124.432 7.36112 125.544 7.1157 126.666 7.14676C127.177 7.14676 127.446 7.08059 127.472 6.94824Z"
            fill="white" />
          <path
            d="M131.28 9.71427C133.635 7.85455 136.585 6.91401 139.581 7.06732C142.895 7.06732 145.31 7.94964 146.825 9.71427C147.602 10.7305 148.137 11.9109 148.389 13.1655C148.641 14.4201 148.604 15.7158 148.28 16.9537C147.877 19.7755 146.469 22.3563 144.314 24.2195C141.964 26.0816 139.018 27.0226 136.025 26.8665C132.571 26.8665 130.116 25.9842 128.662 24.2195C127.208 22.4549 126.768 20.0374 127.34 16.9669C127.738 14.1531 129.137 11.5776 131.28 9.71427ZM134.928 20.6064C135.092 21.0085 135.375 21.3507 135.739 21.5872C136.103 21.8238 136.53 21.9433 136.964 21.9299C137.452 21.9177 137.931 21.7917 138.363 21.562C138.794 21.3322 139.166 21.0051 139.449 20.6064C140.251 19.5169 140.765 18.2422 140.943 16.9007C141.239 15.7395 141.15 14.5136 140.692 13.4068C140.533 13.009 140.257 12.6692 139.9 12.4327C139.544 12.1962 139.123 12.0743 138.696 12.0833C138.203 12.0925 137.719 12.2169 137.283 12.4467C136.847 12.6766 136.471 13.0053 136.184 13.4068C135.372 14.4821 134.853 15.7498 134.677 17.086C134.382 18.2562 134.47 19.4901 134.928 20.6064Z"
            fill="white" />
          <path
            d="M152.47 11.8054C153.409 10.3622 154.684 9.16797 156.184 8.32464C157.59 7.55137 159.167 7.1462 160.771 7.14675C161.98 7.10065 163.179 7.37456 164.248 7.94083C165.04 8.33817 165.681 8.98428 166.072 9.78046L167.672 0.754379C167.737 0.507206 167.737 0.247173 167.672 0L175.035 0C174.865 0.219388 174.755 0.479486 174.717 0.754379L170.262 25.6489C170.168 25.9052 170.168 26.1867 170.262 26.443H162.78C163.054 26.2027 163.224 25.8661 163.256 25.5033L163.494 24.1798C162.847 25.1127 161.922 25.8168 160.85 26.1915C159.691 26.6415 158.458 26.8704 157.215 26.8665C155.741 26.908 154.285 26.5219 153.025 25.7548C151.874 24.9745 151.021 23.8269 150.606 22.499C150.088 20.8085 150.01 19.0134 150.381 17.2845C150.685 15.3314 151.396 13.4644 152.47 11.8054ZM157.955 20.2888C158.145 20.6685 158.441 20.9847 158.807 21.1986C159.174 21.4125 159.594 21.5148 160.018 21.4932C160.495 21.4842 160.963 21.3677 161.389 21.1523C161.815 20.9369 162.186 20.6282 162.476 20.2491C163.254 19.2647 163.756 18.0907 163.931 16.8478C164.153 15.8756 164.017 14.8554 163.547 13.9759C163.347 13.6224 163.054 13.3307 162.699 13.1324C162.345 12.934 161.943 12.8367 161.538 12.8509C161.064 12.8562 160.597 12.9657 160.17 13.1715C159.743 13.3773 159.366 13.6745 159.066 14.042C158.314 14.8954 157.823 15.9476 157.651 17.0728C157.394 18.1489 157.501 19.2802 157.955 20.2888Z"
            fill="white" />
          <path
            d="M192.113 26.4695H186.389C186.161 26.4982 185.93 26.4566 185.727 26.3501C185.524 26.2437 185.358 26.0775 185.252 25.8739C185.058 25.3484 185.026 24.7768 185.159 24.2328C184.56 25.111 183.739 25.8144 182.78 26.271C181.727 26.7329 180.584 26.9544 179.435 26.9195C178.653 26.9946 177.863 26.8716 177.14 26.5618C176.417 26.2519 175.784 25.765 175.298 25.146C174.491 23.9946 174.306 22.0755 174.782 19.4021L176.739 8.2982C176.806 8.05128 176.806 7.79075 176.739 7.54382H184.287C184.117 7.76321 184.008 8.02331 183.97 8.2982L182.264 17.9331C182.069 18.6441 182.101 19.3987 182.357 20.0903C182.483 20.2996 182.665 20.4697 182.882 20.5818C183.099 20.694 183.343 20.7437 183.586 20.7256C184.161 20.7049 184.705 20.4631 185.106 20.0506C185.608 19.5633 185.996 18.9714 186.243 18.3169L188.001 8.2982C188.094 7.79528 188.001 7.54382 188.001 7.54382H195.55C195.417 7.54382 195.312 7.79528 195.219 8.2982L192.165 25.6754C191.967 26.1518 191.994 26.4695 192.113 26.4695Z"
            fill="white" />
          <path
            d="M215.803 18.1713C215.602 18.3926 215.473 18.6693 215.433 18.9653C215.05 21.3561 213.803 23.5227 211.929 25.0533C209.733 26.554 207.102 27.2846 204.447 27.1312C201.301 27.1312 199.023 26.2091 197.613 24.3651C196.876 23.2987 196.377 22.0862 196.149 20.8098C195.921 19.5335 195.97 18.2229 196.291 16.9669C196.686 14.1362 198.028 11.5233 200.098 9.55545C202.306 7.6894 205.145 6.74205 208.03 6.90851C211.079 6.90851 213.282 7.60554 214.639 8.9996C215.333 9.81624 215.83 10.7817 216.091 11.8213C216.352 12.861 216.371 13.9468 216.146 14.9949C216.079 15.2695 216.107 15.5589 216.226 15.8155H208.863C208.985 15.66 209.071 15.4791 209.114 15.2861V14.9552C209.211 14.6691 209.239 14.3638 209.196 14.0646C209.152 13.7655 209.038 13.481 208.863 13.2347C208.643 13.0272 208.383 12.8682 208.098 12.7678C207.814 12.6675 207.511 12.6282 207.21 12.6524C205.373 12.6524 204.209 14.0817 203.694 16.9537C203.379 18.0922 203.453 19.3034 203.905 20.3947C204.073 20.7159 204.326 20.9846 204.636 21.1714C204.946 21.3581 205.302 21.4557 205.664 21.4535C206.329 21.4805 206.985 21.2849 207.527 20.8976C207.785 20.7 208 20.4532 208.161 20.1714C208.323 19.8897 208.426 19.5787 208.466 19.2565V18.9256C208.519 18.6993 208.519 18.4638 208.466 18.2374L215.803 18.1713Z"
            fill="white" />
          <path
            d="M230.886 20.5139L229.775 26.8268C229.775 26.6945 229.564 26.6415 229.062 26.6415H225.704C224.336 26.7214 222.97 26.4479 221.738 25.8475C221.303 25.604 220.926 25.2681 220.634 24.8635C220.341 24.4589 220.141 23.9952 220.046 23.5049C219.834 22.1593 219.874 20.7859 220.165 19.4551L221.487 12.0833H219.438C218.936 12.0833 218.685 12.0833 218.658 12.2819L219.636 6.61741C219.636 6.73652 219.861 6.80269 220.363 6.80269H222.36L222.928 3.58665C223.021 3.08374 222.994 2.83228 222.928 2.83228H230.476C230.344 2.83228 230.238 3.08374 230.146 3.58665L229.59 6.80269H232.234C232.737 6.80269 233.001 6.80269 233.027 6.61741L232.023 12.2819C232.023 12.1495 231.785 12.0833 231.309 12.0833H228.665L227.502 18.7007C227.403 19.0088 227.405 19.3405 227.507 19.6475C227.609 19.9545 227.806 20.2209 228.07 20.408C228.74 20.664 229.458 20.7636 230.172 20.6992C230.608 20.6992 230.873 20.6462 230.886 20.5139Z"
            fill="white" />
        </g>
        <defs>
          <clipPath id="clip0_275_5817">
            <rect width="233" height="34" fill="white" />
          </clipPath>
        </defs>
      </svg>
      <div class="goods-box">
        <div class="gb-list" @click="toDetails" v-for="item, index in newProdouctList" :key="index">
          <div class="gb-pic">
            <img v-lazy="`${item.img}?imageView2/1/w/400/h/400`">
          </div>
          <span class="overflow">{{ item.title }}</span>
          <i>${{ $fn.initPrice(item.price, 0) }}<i>{{ $fn.initPrice(item.price, 1) }}</i></i>
        </div>
      </div>
      <div class="btn-box">
        <span @click="toList('Earrings')">View All</span>
      </div>
    </div>

    <!-- -----------------------Earrings----------------------- -->
    <i class="line"></i>
    <div class="title-box">
      <svg xmlns="http://www.w3.org/2000/svg" width="53" height="12" viewBox="0 0 53 12" fill="none">
        <path
          d="M48.123 2C48.123 3.10457 49.0185 4 50.123 4C51.2276 4 52.123 3.10457 52.123 2C52.123 0.89543 51.2276 0 50.123 0C49.0185 0 48.123 0.89543 48.123 2Z"
          fill="url(#paint0_linear_275_4579)" />
        <path
          d="M40.123 2C40.123 3.10457 41.0185 4 42.123 4C43.2276 4 44.123 3.10457 44.123 2C44.123 0.89543 43.2276 0 42.123 0C41.0185 0 40.123 0.89543 40.123 2Z"
          fill="url(#paint1_linear_275_4579)" />
        <path
          d="M32.123 2C32.123 3.10457 33.0185 4 34.123 4C35.2276 4 36.123 3.10457 36.123 2C36.123 0.89543 35.2276 0 34.123 0C33.0185 0 32.123 0.89543 32.123 2Z"
          fill="url(#paint2_linear_275_4579)" />
        <path
          d="M24.123 2C24.123 3.10457 25.0185 4 26.123 4C27.2276 4 28.123 3.10457 28.123 2C28.123 0.89543 27.2276 0 26.123 0C25.0185 0 24.123 0.89543 24.123 2Z"
          fill="url(#paint3_linear_275_4579)" />
        <path
          d="M48.123 10C48.123 11.1046 49.0185 12 50.123 12C51.2276 12 52.123 11.1046 52.123 10C52.123 8.89543 51.2276 8 50.123 8C49.0185 8 48.123 8.89543 48.123 10Z"
          fill="url(#paint4_linear_275_4579)" />
        <path
          d="M40.123 10C40.123 11.1046 41.0185 12 42.123 12C43.2276 12 44.123 11.1046 44.123 10C44.123 8.89543 43.2276 8 42.123 8C41.0185 8 40.123 8.89543 40.123 10Z"
          fill="url(#paint5_linear_275_4579)" />
        <path
          d="M32.123 10C32.123 11.1046 33.0185 12 34.123 12C35.2276 12 36.123 11.1046 36.123 10C36.123 8.89543 35.2276 8 34.123 8C33.0185 8 32.123 8.89543 32.123 10Z"
          fill="url(#paint6_linear_275_4579)" />
        <path
          d="M24.123 10C24.123 11.1046 25.0185 12 26.123 12C27.2276 12 28.123 11.1046 28.123 10C28.123 8.89543 27.2276 8 26.123 8C25.0185 8 24.123 8.89543 24.123 10Z"
          fill="url(#paint7_linear_275_4579)" />
        <path
          d="M16.123 2C16.123 3.10457 17.0185 4 18.123 4C19.2276 4 20.123 3.10457 20.123 2C20.123 0.89543 19.2276 0 18.123 0C17.0185 0 16.123 0.89543 16.123 2Z"
          fill="url(#paint8_linear_275_4579)" />
        <path
          d="M8.12305 2C8.12305 3.10457 9.01848 4 10.123 4C11.2276 4 12.123 3.10457 12.123 2C12.123 0.89543 11.2276 0 10.123 0C9.01848 0 8.12305 0.89543 8.12305 2Z"
          fill="url(#paint9_linear_275_4579)" />
        <path
          d="M0.123047 2C0.123047 3.10457 1.01848 4 2.12305 4C3.22762 4 4.12305 3.10457 4.12305 2C4.12305 0.89543 3.22762 0 2.12305 0C1.01848 0 0.123047 0.89543 0.123047 2Z"
          fill="url(#paint10_linear_275_4579)" />
        <path
          d="M16.123 10C16.123 11.1046 17.0185 12 18.123 12C19.2276 12 20.123 11.1046 20.123 10C20.123 8.89543 19.2276 8 18.123 8C17.0185 8 16.123 8.89543 16.123 10Z"
          fill="url(#paint11_linear_275_4579)" />
        <path
          d="M8.12305 10C8.12305 11.1046 9.01848 12 10.123 12C11.2276 12 12.123 11.1046 12.123 10C12.123 8.89543 11.2276 8 10.123 8C9.01848 8 8.12305 8.89543 8.12305 10Z"
          fill="url(#paint12_linear_275_4579)" />
        <path
          d="M0.123047 10C0.123047 11.1046 1.01848 12 2.12305 12C3.22762 12 4.12305 11.1046 4.12305 10C4.12305 8.89543 3.22762 8 2.12305 8C1.01848 8 0.123047 8.89543 0.123047 10Z"
          fill="url(#paint13_linear_275_4579)" />
        <defs>
          <linearGradient id="paint0_linear_275_4579" x1="25.123" y1="5.5" x2="52.123" y2="6"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FFA9A7" />
            <stop offset="1" stop-color="#FF3835" />
          </linearGradient>
          <linearGradient id="paint1_linear_275_4579" x1="25.123" y1="5.5" x2="52.123" y2="6"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FFA9A7" />
            <stop offset="1" stop-color="#FF3835" />
          </linearGradient>
          <linearGradient id="paint2_linear_275_4579" x1="25.123" y1="5.5" x2="52.123" y2="6"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FFA9A7" />
            <stop offset="1" stop-color="#FF3835" />
          </linearGradient>
          <linearGradient id="paint3_linear_275_4579" x1="25.123" y1="5.5" x2="52.123" y2="6"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FFA9A7" />
            <stop offset="1" stop-color="#FF3835" />
          </linearGradient>
          <linearGradient id="paint4_linear_275_4579" x1="25.123" y1="5.5" x2="52.123" y2="6"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FFA9A7" />
            <stop offset="1" stop-color="#FF3835" />
          </linearGradient>
          <linearGradient id="paint5_linear_275_4579" x1="25.123" y1="5.5" x2="52.123" y2="6"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FFA9A7" />
            <stop offset="1" stop-color="#FF3835" />
          </linearGradient>
          <linearGradient id="paint6_linear_275_4579" x1="25.123" y1="5.5" x2="52.123" y2="6"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FFA9A7" />
            <stop offset="1" stop-color="#FF3835" />
          </linearGradient>
          <linearGradient id="paint7_linear_275_4579" x1="25.123" y1="5.5" x2="52.123" y2="6"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FFA9A7" />
            <stop offset="1" stop-color="#FF3835" />
          </linearGradient>
          <linearGradient id="paint8_linear_275_4579" x1="25.123" y1="5.5" x2="52.123" y2="6"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FFA9A7" />
            <stop offset="1" stop-color="#FF3835" />
          </linearGradient>
          <linearGradient id="paint9_linear_275_4579" x1="25.123" y1="5.5" x2="52.123" y2="6"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FFA9A7" />
            <stop offset="1" stop-color="#FF3835" />
          </linearGradient>
          <linearGradient id="paint10_linear_275_4579" x1="25.123" y1="5.5" x2="52.123" y2="6"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FFA9A7" />
            <stop offset="1" stop-color="#FF3835" />
          </linearGradient>
          <linearGradient id="paint11_linear_275_4579" x1="25.123" y1="5.5" x2="52.123" y2="6"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FFA9A7" />
            <stop offset="1" stop-color="#FF3835" />
          </linearGradient>
          <linearGradient id="paint12_linear_275_4579" x1="25.123" y1="5.5" x2="52.123" y2="6"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FFA9A7" />
            <stop offset="1" stop-color="#FF3835" />
          </linearGradient>
          <linearGradient id="paint13_linear_275_4579" x1="25.123" y1="5.5" x2="52.123" y2="6"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FFA9A7" />
            <stop offset="1" stop-color="#FF3835" />
          </linearGradient>
        </defs>
      </svg>
      <span>Earrings</span>
      <svg xmlns="http://www.w3.org/2000/svg" width="53" height="12" viewBox="0 0 53 12" fill="none">
        <path
          d="M4.12305 2C4.12305 3.10457 3.22762 4 2.12305 4C1.01848 4 0.123047 3.10457 0.123047 2C0.123047 0.89543 1.01848 0 2.12305 0C3.22762 0 4.12305 0.89543 4.12305 2Z"
          fill="url(#paint0_linear_275_4584)" />
        <path
          d="M12.123 2C12.123 3.10457 11.2276 4 10.123 4C9.01848 4 8.12305 3.10457 8.12305 2C8.12305 0.89543 9.01848 0 10.123 0C11.2276 0 12.123 0.89543 12.123 2Z"
          fill="url(#paint1_linear_275_4584)" />
        <path
          d="M20.123 2C20.123 3.10457 19.2276 4 18.123 4C17.0185 4 16.123 3.10457 16.123 2C16.123 0.89543 17.0185 0 18.123 0C19.2276 0 20.123 0.89543 20.123 2Z"
          fill="url(#paint2_linear_275_4584)" />
        <path
          d="M28.123 2C28.123 3.10457 27.2276 4 26.123 4C25.0185 4 24.123 3.10457 24.123 2C24.123 0.89543 25.0185 0 26.123 0C27.2276 0 28.123 0.89543 28.123 2Z"
          fill="url(#paint3_linear_275_4584)" />
        <path
          d="M4.12305 10C4.12305 11.1046 3.22762 12 2.12305 12C1.01848 12 0.123047 11.1046 0.123047 10C0.123047 8.89543 1.01848 8 2.12305 8C3.22762 8 4.12305 8.89543 4.12305 10Z"
          fill="url(#paint4_linear_275_4584)" />
        <path
          d="M12.123 10C12.123 11.1046 11.2276 12 10.123 12C9.01848 12 8.12305 11.1046 8.12305 10C8.12305 8.89543 9.01848 8 10.123 8C11.2276 8 12.123 8.89543 12.123 10Z"
          fill="url(#paint5_linear_275_4584)" />
        <path
          d="M20.123 10C20.123 11.1046 19.2276 12 18.123 12C17.0185 12 16.123 11.1046 16.123 10C16.123 8.89543 17.0185 8 18.123 8C19.2276 8 20.123 8.89543 20.123 10Z"
          fill="url(#paint6_linear_275_4584)" />
        <path
          d="M28.123 10C28.123 11.1046 27.2276 12 26.123 12C25.0185 12 24.123 11.1046 24.123 10C24.123 8.89543 25.0185 8 26.123 8C27.2276 8 28.123 8.89543 28.123 10Z"
          fill="url(#paint7_linear_275_4584)" />
        <path
          d="M36.123 2C36.123 3.10457 35.2276 4 34.123 4C33.0185 4 32.123 3.10457 32.123 2C32.123 0.89543 33.0185 0 34.123 0C35.2276 0 36.123 0.89543 36.123 2Z"
          fill="url(#paint8_linear_275_4584)" />
        <path
          d="M36.123 10C36.123 11.1046 35.2276 12 34.123 12C33.0185 12 32.123 11.1046 32.123 10C32.123 8.89543 33.0185 8 34.123 8C35.2276 8 36.123 8.89543 36.123 10Z"
          fill="url(#paint9_linear_275_4584)" />
        <path
          d="M44.123 2C44.123 3.10457 43.2276 4 42.123 4C41.0185 4 40.123 3.10457 40.123 2C40.123 0.89543 41.0185 0 42.123 0C43.2276 0 44.123 0.89543 44.123 2Z"
          fill="url(#paint10_linear_275_4584)" />
        <path
          d="M44.123 10C44.123 11.1046 43.2276 12 42.123 12C41.0185 12 40.123 11.1046 40.123 10C40.123 8.89543 41.0185 8 42.123 8C43.2276 8 44.123 8.89543 44.123 10Z"
          fill="url(#paint11_linear_275_4584)" />
        <path
          d="M52.123 2C52.123 3.10457 51.2276 4 50.123 4C49.0185 4 48.123 3.10457 48.123 2C48.123 0.89543 49.0185 0 50.123 0C51.2276 0 52.123 0.89543 52.123 2Z"
          fill="url(#paint12_linear_275_4584)" />
        <path
          d="M52.123 10C52.123 11.1046 51.2276 12 50.123 12C49.0185 12 48.123 11.1046 48.123 10C48.123 8.89543 49.0185 8 50.123 8C51.2276 8 52.123 8.89543 52.123 10Z"
          fill="url(#paint13_linear_275_4584)" />
        <defs>
          <linearGradient id="paint0_linear_275_4584" x1="27.123" y1="5.5" x2="0.123047" y2="6"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FFA9A7" />
            <stop offset="1" stop-color="#FF3835" />
          </linearGradient>
          <linearGradient id="paint1_linear_275_4584" x1="27.123" y1="5.5" x2="0.123047" y2="6"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FFA9A7" />
            <stop offset="1" stop-color="#FF3835" />
          </linearGradient>
          <linearGradient id="paint2_linear_275_4584" x1="27.123" y1="5.5" x2="0.123047" y2="6"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FFA9A7" />
            <stop offset="1" stop-color="#FF3835" />
          </linearGradient>
          <linearGradient id="paint3_linear_275_4584" x1="27.123" y1="5.5" x2="0.123047" y2="6"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FFA9A7" />
            <stop offset="1" stop-color="#FF3835" />
          </linearGradient>
          <linearGradient id="paint4_linear_275_4584" x1="27.123" y1="5.5" x2="0.123047" y2="6"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FFA9A7" />
            <stop offset="1" stop-color="#FF3835" />
          </linearGradient>
          <linearGradient id="paint5_linear_275_4584" x1="27.123" y1="5.5" x2="0.123047" y2="6"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FFA9A7" />
            <stop offset="1" stop-color="#FF3835" />
          </linearGradient>
          <linearGradient id="paint6_linear_275_4584" x1="27.123" y1="5.5" x2="0.123047" y2="6"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FFA9A7" />
            <stop offset="1" stop-color="#FF3835" />
          </linearGradient>
          <linearGradient id="paint7_linear_275_4584" x1="27.123" y1="5.5" x2="0.123047" y2="6"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FFA9A7" />
            <stop offset="1" stop-color="#FF3835" />
          </linearGradient>
          <linearGradient id="paint8_linear_275_4584" x1="27.123" y1="5.5" x2="0.123047" y2="6"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FFA9A7" />
            <stop offset="1" stop-color="#FF3835" />
          </linearGradient>
          <linearGradient id="paint9_linear_275_4584" x1="27.123" y1="5.5" x2="0.123047" y2="6"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FFA9A7" />
            <stop offset="1" stop-color="#FF3835" />
          </linearGradient>
          <linearGradient id="paint10_linear_275_4584" x1="27.123" y1="5.5" x2="0.123047" y2="6"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FFA9A7" />
            <stop offset="1" stop-color="#FF3835" />
          </linearGradient>
          <linearGradient id="paint11_linear_275_4584" x1="27.123" y1="5.5" x2="0.123047" y2="6"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FFA9A7" />
            <stop offset="1" stop-color="#FF3835" />
          </linearGradient>
          <linearGradient id="paint12_linear_275_4584" x1="27.123" y1="5.5" x2="0.123047" y2="6"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FFA9A7" />
            <stop offset="1" stop-color="#FF3835" />
          </linearGradient>
          <linearGradient id="paint13_linear_275_4584" x1="27.123" y1="5.5" x2="0.123047" y2="6"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FFA9A7" />
            <stop offset="1" stop-color="#FF3835" />
          </linearGradient>
        </defs>
      </svg>
    </div>

    <div class="goods-box">
      <div class="gb-list" @click="toDetails" v-for="item, index in earringsList" :key="index">
        <div class="gb-pic">
          <img v-lazy="`${item.img}?imageView2/1/w/400/h/400`">
        </div>
        <span class="overflow">{{ item.title }}</span>
        <i>${{ $fn.initPrice(item.price, 0) }}<i>{{ $fn.initPrice(item.price, 1) }}</i></i>
      </div>
    </div>
    <div class="btn-box2">
      <span @click="toList('Earrings')">View All</span>
    </div>

    <!-- -----------------------rings----------------------- -->
    <i class="line"></i>
    <div class="rings-title-box">
      <svg xmlns="http://www.w3.org/2000/svg" width="261" height="10" viewBox="0 0 261 10" fill="none">
        <path d="M236 0H234L230 10H232L236 0Z" fill="url(#paint0_linear_275_4754)" />
        <path d="M256 0H254L250 10H252L256 0Z" fill="url(#paint1_linear_275_4754)" />
        <path d="M226 0H224L220 10H222L226 0Z" fill="url(#paint2_linear_275_4754)" />
        <path d="M246 0H244L240 10H242L246 0Z" fill="url(#paint3_linear_275_4754)" />
        <path d="M241 0H239L235 10H237L241 0Z" fill="url(#paint4_linear_275_4754)" />
        <path d="M261 0H259L255 10H257L261 0Z" fill="url(#paint5_linear_275_4754)" />
        <path d="M231 0H229L225 10H227L231 0Z" fill="url(#paint6_linear_275_4754)" />
        <path d="M251 0H249L245 10H247L251 0Z" fill="url(#paint7_linear_275_4754)" />
        <path d="M76 0H74L70 10H72L76 0Z" fill="url(#paint8_linear_275_4754)" />
        <path d="M96 0H94L90 10H92L96 0Z" fill="url(#paint9_linear_275_4754)" />
        <path d="M66 0H64L60 10H62L66 0Z" fill="url(#paint10_linear_275_4754)" />
        <path d="M86 0H84L80 10H82L86 0Z" fill="url(#paint11_linear_275_4754)" />
        <path d="M81 0H79L75 10H77L81 0Z" fill="url(#paint12_linear_275_4754)" />
        <path d="M101 0H99L95 10H97L101 0Z" fill="url(#paint13_linear_275_4754)" />
        <path d="M71 0H69L65 10H67L71 0Z" fill="url(#paint14_linear_275_4754)" />
        <path d="M91 0H89L85 10H87L91 0Z" fill="url(#paint15_linear_275_4754)" />
        <path d="M156 0H154L150 10H152L156 0Z" fill="url(#paint16_linear_275_4754)" />
        <path d="M176 0H174L170 10H172L176 0Z" fill="url(#paint17_linear_275_4754)" />
        <path d="M146 0H144L140 10H142L146 0Z" fill="url(#paint18_linear_275_4754)" />
        <path d="M166 0H164L160 10H162L166 0Z" fill="url(#paint19_linear_275_4754)" />
        <path d="M161 0H159L155 10H157L161 0Z" fill="url(#paint20_linear_275_4754)" />
        <path d="M181 0H179L175 10H177L181 0Z" fill="url(#paint21_linear_275_4754)" />
        <path d="M151 0H149L145 10H147L151 0Z" fill="url(#paint22_linear_275_4754)" />
        <path d="M171 0H169L165 10H167L171 0Z" fill="url(#paint23_linear_275_4754)" />
        <path d="M16 0H14L10 10H12L16 0Z" fill="url(#paint24_linear_275_4754)" />
        <path d="M6 0H4L0 10H2L6 0Z" fill="url(#paint25_linear_275_4754)" />
        <path d="M21 0H19L15 10H17L21 0Z" fill="url(#paint26_linear_275_4754)" />
        <path d="M11 0H9L5 10H7L11 0Z" fill="url(#paint27_linear_275_4754)" />
        <path d="M196 0H194L190 10H192L196 0Z" fill="url(#paint28_linear_275_4754)" />
        <path d="M216 0H214L210 10H212L216 0Z" fill="url(#paint29_linear_275_4754)" />
        <path d="M186 0H184L180 10H182L186 0Z" fill="url(#paint30_linear_275_4754)" />
        <path d="M206 0H204L200 10H202L206 0Z" fill="url(#paint31_linear_275_4754)" />
        <path d="M201 0H199L195 10H197L201 0Z" fill="url(#paint32_linear_275_4754)" />
        <path d="M221 0H219L215 10H217L221 0Z" fill="url(#paint33_linear_275_4754)" />
        <path d="M191 0H189L185 10H187L191 0Z" fill="url(#paint34_linear_275_4754)" />
        <path d="M211 0H209L205 10H207L211 0Z" fill="url(#paint35_linear_275_4754)" />
        <path d="M36 0H34L30 10H32L36 0Z" fill="url(#paint36_linear_275_4754)" />
        <path d="M56 0H54L50 10H52L56 0Z" fill="url(#paint37_linear_275_4754)" />
        <path d="M26 0H24L20 10H22L26 0Z" fill="url(#paint38_linear_275_4754)" />
        <path d="M46 0H44L40 10H42L46 0Z" fill="url(#paint39_linear_275_4754)" />
        <path d="M41 0H39L35 10H37L41 0Z" fill="url(#paint40_linear_275_4754)" />
        <path d="M61 0H59L55 10H57L61 0Z" fill="url(#paint41_linear_275_4754)" />
        <path d="M31 0H29L25 10H27L31 0Z" fill="url(#paint42_linear_275_4754)" />
        <path d="M51 0H49L45 10H47L51 0Z" fill="url(#paint43_linear_275_4754)" />
        <path d="M116 0H114L110 10H112L116 0Z" fill="url(#paint44_linear_275_4754)" />
        <path d="M136 0H134L130 10H132L136 0Z" fill="url(#paint45_linear_275_4754)" />
        <path d="M106 0H104L100 10H102L106 0Z" fill="url(#paint46_linear_275_4754)" />
        <path d="M126 0H124L120 10H122L126 0Z" fill="url(#paint47_linear_275_4754)" />
        <path d="M121 0H119L115 10H117L121 0Z" fill="url(#paint48_linear_275_4754)" />
        <path d="M141 0H139L135 10H137L141 0Z" fill="url(#paint49_linear_275_4754)" />
        <path d="M111 0H109L105 10H107L111 0Z" fill="url(#paint50_linear_275_4754)" />
        <path d="M131 0H129L125 10H127L131 0Z" fill="url(#paint51_linear_275_4754)" />
        <defs>
          <linearGradient id="paint0_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint1_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint2_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint3_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint4_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint5_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint6_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint7_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint8_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint9_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint10_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint11_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint12_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint13_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint14_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint15_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint16_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint17_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint18_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint19_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint20_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint21_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint22_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint23_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint24_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint25_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint26_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint27_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint28_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint29_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint30_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint31_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint32_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint33_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint34_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint35_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint36_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint37_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint38_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint39_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint40_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint41_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint42_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint43_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint44_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint45_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint46_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint47_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint48_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint49_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint50_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint51_linear_275_4754" x1="-380" y1="5" x2="260.999" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
        </defs>
      </svg>
      <span>Rings</span>
      <svg xmlns="http://www.w3.org/2000/svg" width="261" height="10" viewBox="0 0 261 10" fill="none">
        <path d="M25 10H27L31 0H29L25 10Z" fill="url(#paint0_linear_275_4756)" />
        <path d="M5 10H7L11 0H9L5 10Z" fill="url(#paint1_linear_275_4756)" />
        <path d="M35 10H37L41 0H39L35 10Z" fill="url(#paint2_linear_275_4756)" />
        <path d="M15 10H17L21 0H19L15 10Z" fill="url(#paint3_linear_275_4756)" />
        <path d="M20 10H22L26 0H24L20 10Z" fill="url(#paint4_linear_275_4756)" />
        <path d="M0 10H2L6 0H4L0 10Z" fill="url(#paint5_linear_275_4756)" />
        <path d="M30 10H32L36 0H34L30 10Z" fill="url(#paint6_linear_275_4756)" />
        <path d="M10 10H12L16 0H14L10 10Z" fill="url(#paint7_linear_275_4756)" />
        <path d="M185 10H187L191 0H189L185 10Z" fill="url(#paint8_linear_275_4756)" />
        <path d="M165 10H167L171 0H169L165 10Z" fill="url(#paint9_linear_275_4756)" />
        <path d="M195 10H197L201 0H199L195 10Z" fill="url(#paint10_linear_275_4756)" />
        <path d="M175 10H177L181 0H179L175 10Z" fill="url(#paint11_linear_275_4756)" />
        <path d="M180 10H182L186 0H184L180 10Z" fill="url(#paint12_linear_275_4756)" />
        <path d="M160 10H162L166 0H164L160 10Z" fill="url(#paint13_linear_275_4756)" />
        <path d="M190 10H192L196 0H194L190 10Z" fill="url(#paint14_linear_275_4756)" />
        <path d="M170 10H172L176 0H174L170 10Z" fill="url(#paint15_linear_275_4756)" />
        <path d="M105 10H107L111 0H109L105 10Z" fill="url(#paint16_linear_275_4756)" />
        <path d="M85 10H87L91 0H89L85 10Z" fill="url(#paint17_linear_275_4756)" />
        <path d="M115 10H117L121 0H119L115 10Z" fill="url(#paint18_linear_275_4756)" />
        <path d="M95 10H97L101 0H99L95 10Z" fill="url(#paint19_linear_275_4756)" />
        <path d="M100 10H102L106 0H104L100 10Z" fill="url(#paint20_linear_275_4756)" />
        <path d="M80 10H82L86 0H84L80 10Z" fill="url(#paint21_linear_275_4756)" />
        <path d="M110 10H112L116 0H114L110 10Z" fill="url(#paint22_linear_275_4756)" />
        <path d="M90 10H92L96 0H94L90 10Z" fill="url(#paint23_linear_275_4756)" />
        <path d="M245 10H247L251 0H249L245 10Z" fill="url(#paint24_linear_275_4756)" />
        <path d="M255 10H257L261 0H259L255 10Z" fill="url(#paint25_linear_275_4756)" />
        <path d="M240 10H242L246 0H244L240 10Z" fill="url(#paint26_linear_275_4756)" />
        <path d="M250 10H252L256 0H254L250 10Z" fill="url(#paint27_linear_275_4756)" />
        <path d="M65 10H67L71 0H69L65 10Z" fill="url(#paint28_linear_275_4756)" />
        <path d="M45 10H47L51 0H49L45 10Z" fill="url(#paint29_linear_275_4756)" />
        <path d="M75 10H77L81 0H79L75 10Z" fill="url(#paint30_linear_275_4756)" />
        <path d="M55 10H57L61 0H59L55 10Z" fill="url(#paint31_linear_275_4756)" />
        <path d="M60 10H62L66 0H64L60 10Z" fill="url(#paint32_linear_275_4756)" />
        <path d="M40 10H42L46 0H44L40 10Z" fill="url(#paint33_linear_275_4756)" />
        <path d="M70 10H72L76 0H74L70 10Z" fill="url(#paint34_linear_275_4756)" />
        <path d="M50 10H52L56 0H54L50 10Z" fill="url(#paint35_linear_275_4756)" />
        <path d="M225 10H227L231 0H229L225 10Z" fill="url(#paint36_linear_275_4756)" />
        <path d="M205 10H207L211 0H209L205 10Z" fill="url(#paint37_linear_275_4756)" />
        <path d="M235 10H237L241 0H239L235 10Z" fill="url(#paint38_linear_275_4756)" />
        <path d="M215 10H217L221 0H219L215 10Z" fill="url(#paint39_linear_275_4756)" />
        <path d="M220 10H222L226 0H224L220 10Z" fill="url(#paint40_linear_275_4756)" />
        <path d="M200 10H202L206 0H204L200 10Z" fill="url(#paint41_linear_275_4756)" />
        <path d="M230 10H232L236 0H234L230 10Z" fill="url(#paint42_linear_275_4756)" />
        <path d="M210 10H212L216 0H214L210 10Z" fill="url(#paint43_linear_275_4756)" />
        <path d="M145 10H147L151 0H149L145 10Z" fill="url(#paint44_linear_275_4756)" />
        <path d="M125 10H127L131 0H129L125 10Z" fill="url(#paint45_linear_275_4756)" />
        <path d="M155 10H157L161 0H159L155 10Z" fill="url(#paint46_linear_275_4756)" />
        <path d="M135 10H137L141 0H139L135 10Z" fill="url(#paint47_linear_275_4756)" />
        <path d="M140 10H142L146 0H144L140 10Z" fill="url(#paint48_linear_275_4756)" />
        <path d="M120 10H122L126 0H124L120 10Z" fill="url(#paint49_linear_275_4756)" />
        <path d="M150 10H152L156 0H154L150 10Z" fill="url(#paint50_linear_275_4756)" />
        <path d="M130 10H132L136 0H134L130 10Z" fill="url(#paint51_linear_275_4756)" />
        <defs>
          <linearGradient id="paint0_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint1_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint2_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint3_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint4_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint5_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint6_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint7_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint8_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint9_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint10_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint11_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint12_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint13_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint14_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint15_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint16_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint17_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint18_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint19_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint20_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint21_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint22_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint23_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint24_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint25_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint26_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint27_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint28_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint29_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint30_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint31_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint32_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint33_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint34_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint35_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint36_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint37_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint38_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint39_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint40_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint41_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint42_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint43_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint44_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint45_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint46_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint47_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint48_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint49_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint50_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
          <linearGradient id="paint51_linear_275_4756" x1="641" y1="5" x2="0.000649511" y2="5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF6634" stop-opacity="0.32" />
            <stop offset="1" stop-color="#FF6634" />
          </linearGradient>
        </defs>
      </svg>
    </div>
    <div class="goods-box">
      <div class="gb-list" @click="toDetails" v-for="item, index in ringsList" :key="index">
        <div class="gb-pic">
          <img v-lazy="`${item.img}?imageView2/1/w/400/h/400`">
        </div>
        <span class="overflow">{{ item.title }}</span>
        <i>${{ $fn.initPrice(item.price, 0) }}<i>{{ $fn.initPrice(item.price, 1) }}</i></i>
      </div>
    </div>
    <div class="btn-box2">
      <span @click="toList('Earrings')">View All</span>
    </div>

    <!-- 底部View -->
    <div class="bottom-box">
      <div class="bottom-hint">
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
            <path
              d="M31.875 17C31.875 8.78477 25.2152 2.125 17 2.125C8.78477 2.125 2.125 8.78476 2.125 17C2.125 25.2152 8.78476 31.875 17 31.875C25.2152 31.875 31.875 25.2152 31.875 17ZM18.0625 8.50064V20.1875H15.9375V8.50064H18.0625ZM15.7129 23.375H18.2629V25.925H15.7129V23.375Z"
              fill="#FF7D00" />
          </svg>
          <span>
            正在预览“克隆后的外贸网站”，内容仅供参考，非上线效果！
          </span>
        </div>
        <div>
          <span @click="$router.push('/advert/advert1')">去克隆我的外贸网站</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
            <path
              d="M13.7288 26.4768L11.7754 24.5234L19.2987 17.0001L11.7754 9.47681L13.7288 7.52342L23.2055 17.0001L13.7288 26.4768Z"
              fill="#FF7D00" />
          </svg>
        </div>
      </div>
      <van-tabbar style="position: static;" v-model="active" id="homeTabbar" @change="active = 'Home'">
        <van-tabbar-item :name="item.name" v-for="item, index in tabList" :key="index">
          <span>{{ item.title }}</span>
          <template #icon="props">
            <img :src="require(`../../assets/icon/${props.active ? item.active : item.inactive}.png`)" />
          </template>
        </van-tabbar-item>
      </van-tabbar>
    </div>
    <div v-show="showModal" class="video-box">
      <Overlay :show="showModal" @click="pauseVideo"></Overlay>
      <video ref="videoPlayer" src="https://xhdata.wan4.com/20241204164609_rec_.mp4" controls></video>

    </div>

  </div>

</template>
<script>
import { Overlay } from 'vant';
export default {
  name: 'Maker',
  components: {
    Overlay
  },
  props: {},
  data() {
    return {
      active: 'Home',
      tabList: [
        {
          title: '首页',
          name: 'Home',//对应route 中配置的 name
          inactive: 'icon-tab-home',
          active: 'icon-tab-makcer-home-active',
          url: '/',
          badge: '',
        },
        {
          title: '分类',
          name: 'ClassifyList',//对应route 中配置的 name
          inactive: 'icon-tab-class',
          active: 'icon-tab-class-active',
          url: '/goods/classifyList',
          badge: '',
        },
        {
          title: '采购车',
          name: 'Cart',//对应route 中配置的 name
          inactive: 'icon-tab-cart',
          active: 'icon-tab-cart-active',
          url: '/goods/cart',
          badge: '',
        },
        {
          title: '我的',
          name: 'User',//对应route 中配置的 name
          inactive: 'icon-tab-user',
          active: 'icon-tab-user-active',
          url: '/user',
          badge: '',
        }
      ],
      classList: [
        {
          img: 'https://xhdata.wan4.com/wsw-pc-111.png',
          title: 'Ear Studs',
        },
        {
          img: 'https://xhdata.wan4.com/wsw-pc-112.png',
          title: 'Earrings',
        },
        {
          img: 'https://xhdata.wan4.com/wsw-pc-113.png',
          title: 'Necklaces',
        },
        {
          img: 'https://xhdata.wan4.com/wsw-pc-114.png',
          title: 'Pendants',
        },
        {
          img: 'https://xhdata.wan4.com/wsw-pc-115.png',
          title: 'Bracelets',
        },
        {
          img: 'https://xhdata.wan4.com/wsw-pc-116.png',
          title: 'Bangles',
        },
        {
          img: 'https://xhdata.wan4.com/wsw-pc-117.png',
          title: 'Rings',
        },
        {
          img: 'https://xhdata.wan4.com/wsw-pc-118.png',
          title: 'Anklets',
        },
        {
          img: 'https://xhdata.wan4.com/wsw-pc-119.png',
          title: 'Piecing',
        },
        {
          img: 'https://xhdata.wan4.com/wsw-pc-120.png',
          title: 'Jewelry Set',
        },
        {
          img: 'https://xhdata.wan4.com/wsw-pc-121.png',
          title: 'Cuff-Links',
        },
        {
          img: 'https://xhdata.wan4.com/wsw-pc-122.png',
          title: 'Barrettes',
        },
        {
          img: 'https://xhdata.wan4.com/wsw-pc-123.png',
          title: 'Brooches',
        },
        {
          img: 'https://xhdata.wan4.com/wsw-pc-124.png',
          title: 'Watch Bands',
        },

      ],
      newProdouctList: [
        {
          img: 'https://xhdata.wan4.com/wsw-pc-125.png',
          title: 'New Arrival Jewelry Copper C...',
          price: '311'
        },
        {
          img: 'https://xhdata.wan4.com/wsw-pc-126.png',
          title: 'Wholesale Cute Christmas Je...',
          price: '149'
        },
        {
          img: 'https://xhdata.wan4.com/wsw-pc-127.png',
          title: 'Hot Sale Stainless Steel Christ...',
          price: '226'
        },
        {
          img: 'https://xhdata.wan4.com/wsw-pc-130.png',
          title: 'Cute Jewelry Christmas Zircon...',
          price: '277'
        },
        {
          img: 'https://xhdata.wan4.com/wsw-pc-128.png',
          title: 'Trendy Brass Colorful Zircon...',
          price: '447'
        },
        {
          img: 'https://xhdata.wan4.com/wsw-pc-129.png',
          title: 'Trendy Wholesale Jewelry Chri...',
          price: '178'
        },
      ],
      earringsList: [
        {
          img: 'https://xhdata.wan4.com/wsw-pc-131.png',
          title: 'Wholesale Irregular Texture Holl...',
          price: '311'
        },
        {
          img: 'https://xhdata.wan4.com/wsw-pc-132.png',
          title: 'Wholesale Cutout Design Geome...',
          price: '102'
        },
        {
          img: 'https://xhdata.wan4.com/wsw-pc-133.png',
          title: 'Wholesale Sun Planet Inlaid Fritil...',
          price: '180'
        },
        {
          img: 'https://xhdata.wan4.com/wsw-pc-134.png',
          title: 'Wholesale Bow-Shaped Tassel...',
          price: '249'
        },
        {
          img: 'https://xhdata.wan4.com/wsw-pc-135.png',
          title: 'Wholesale Personalized Texture...',
          price: '282'
        },
        {
          img: 'https://xhdata.wan4.com/wsw-pc-136.png',
          title: 'Wholesale Geometric Embossed...',
          price: '260'
        },
      ],
      ringsList: [
        {
          img: 'https://xhdata.wan4.com/wsw-pc-137.png',
          title: 'Punk Stainless Steel Fine Jewelr...',
          price: '290'
        },
        {
          img: 'https://xhdata.wan4.com/wsw-pc-138.png',
          title: 'Trendy Simple Design Jewelry 18...',
          price: '055'
        },
        {
          img: 'https://xhdata.wan4.com/wsw-pc-139.png',
          title: 'Wholesale Vintage High Polish Fl...',
          price: '199'
        },
        {
          img: 'https://xhdata.wan4.com/wsw-pc-140.png',
          title: 'Elegant Modern White Shell Zirc...',
          price: '228'
        },
        {
          img: 'https://xhdata.wan4.com/wsw-pc-141.png',
          title: 'Unique 18K Gold Plated Irregular...',
          price: '287'
        },
        {
          img: 'https://xhdata.wan4.com/wsw-pc-142.png',
          title: 'Wholesale Retro Design Stainles...',
          price: '221'
        },
      ],
      showModal: false,
    }
  },

  created() {
  },
  methods: {
    toList(tag) {
      this.$router.push('/maker/earrings?tag=' + tag)
    },
    toDetails() {
      this.$router.push('/maker/details')
    },
    showTosat(text) {
      this.$toastUtil.show(text)
    },
    playVideo() {
      this.showModal = true
      this.$refs.videoPlayer.play();
    },
    pauseVideo() {
      this.$refs.videoPlayer.pause();
      this.showModal = false
    },
  }
}
</script>
<style lang="less" scoped>

.video-box{
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  display: flex;
  align-items: center;


  >video{
    width: 100vw;
    z-index: 2;
  }
}
.maker-box {
  display: flex;
  flex-direction: column;
  background: #fff;
  height: auto;
  padding-bottom: calc(env(safe-area-inset-bottom) + 240px);

  .icon-logo {
    width: 218px;
    height: 34px;
    margin: 0;
  }

  .search-box {
    width: 199px;
  }

  .top-tab-box {
    display: flex;
    height: 78px;
    align-items: center;
    padding: 0 24px;
    margin-top: 82px;
    overflow-x: scroll;
    scrollbar-width: none;
    /* 对于 Firefox 隐藏滚动条 */

    &::-webkit-scrollbar {
      display: none;
      /* 对于 Chrome, Safari 和 Opera 隐藏滚动条 */
    }

    >span {
      color: #333;
      font-size: 28px;
      font-style: normal;
      font-weight: 400;
      line-height: 38px;
      margin-right: 34px;
      white-space: nowrap;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .banner {
    margin: 4px 24px 0;
    width: 702px;
    height: 280px;
  }

  .min-banner-box {
    display: flex;
    margin: 18px 24px 0;
    justify-content: space-between;

    >img {
      width: 345px;
      height: 128px;
      margin: 0;
    }
  }

  .class-box {
    display: grid;
    grid-template-columns: repeat(7, 196px);
    padding: 0 24px;
    margin: 32px 0 0;
    grid-gap: 28px 24px;
    overflow-x: scroll;
    overflow-y: hidden;
    scrollbar-width: none;
    /* 对于 Firefox 隐藏滚动条 */

    &::-webkit-scrollbar {
      display: none;
      /* 对于 Chrome, Safari 和 Opera 隐藏滚动条 */
    }


    >div {
      display: flex;
      flex-direction: column;
      width: 100%;
      align-items: center;

      .pic {
        width: 100%;
        position: relative;
        overflow: hidden;
        border-radius: 100%;
        background: #EDEDED;

        &::before {
          content: '';
          display: block;
          padding-bottom: 100%;
        }

        >img {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
        }
      }

      >span {
        margin-top: 12px;
        color: #111;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 34px;
      }
    }
  }

  .new-product {
    display: flex;
    flex-direction: column;
    border-radius: 12px 12px 0px 0px;
    background: linear-gradient(90deg, #B82CD4 0%, #4525EF 100%);
    margin: 28px 18px 0;
    padding: 4px;

    >svg {
      width: 233px;
      height: 34px;
      margin: 22px 20px 20px;
    }

    >div {
      padding: 18px 18px 0;
      margin: 0 !important;
    }
  }

  .goods-box {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 18px 14px;
    background: #fff;
    margin: 24px 24px 0;

    .gb-list {
      display: flex;
      flex-direction: column;
      width: 100%;
      overflow: hidden;
      border-radius: 12px;

      .gb-pic {
        width: 100%;
        position: relative;

        &::before {
          content: '';
          display: block;
          padding-bottom: 100%;
          /* 使高度等于宽度 */
        }

        >img {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
        }
      }

      >span {
        color: #333;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 34px;
        margin-left: 10px;
      }

      >i {
        color: #F53F3F;
        font-family: Arial;
        font-size: 34px;
        font-style: normal;
        font-weight: 700;
        line-height: 48px;
        margin-top: 6px;
        margin-left: 10px;
        margin-bottom: 18px;

        >i {
          color: #F53F3F;
          font-family: Arial;
          font-size: 24px;
          font-style: normal;
          font-weight: 700;
          line-height: 48px;
        }
      }
    }
  }

  .btn-box {
    width: 100%;
    display: flex;
    align-items: center;
    background: #fff;

    >span {
      border-radius: 8px;
      border: 2px solid #6937E3;
      color: #6937E3;
      text-align: center;
      font-size: 26px;
      font-style: normal;
      font-weight: 400;
      padding: 21px 38px;
      margin: 10px auto 32px;
    }
  }

  .btn-box2 {
    width: 100%;
    display: flex;
    align-items: center;
    background: #fff;

    >span {
      border-radius: 8px;
      border: 2px solid #F53F3F;
      color: #F53F3F;
      text-align: center;
      font-size: 26px;
      font-style: normal;
      font-weight: 400;
      padding: 21px 38px;
      margin: 10px auto 0;
    }
  }

  .line {
    height: 18px;
    width: 100vw;
    margin: 44px 0;
    background: #F4F4F4;
  }

  .title-box {
    display: flex;
    align-items: center;
    margin: 0 auto;

    >svg {
      width: 52px;
      height: 12px;
    }

    >span {
      color: #F53F3F;
      font-size: 38px;
      font-style: normal;
      font-weight: 600;
      line-height: 52px;
      margin: 0 18px;
    }
  }

  .rings-title-box {
    display: flex;
    align-items: center;
    margin: 0 auto;

    >svg {
      width: 261px;
      height: 10px;
    }

    >span {
      color: #F53F3F;
      font-size: 38px;
      font-style: normal;
      font-weight: 600;
      line-height: 52px;
      margin: 0 24px;
    }
  }
}

.bottom-box {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;

  .bottom-hint {
    background: #FFE4BA;
    display: flex;
    flex-direction: column;
    padding: 12px 26px;

    >div {
      display: flex;
      align-items: center;

      >svg {
        width: 34px;
        height: 34px;
      }

      >span {
        color: #FF7D00;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 34px;
        margin-left: 10px;
      }
    }

    >div+div {
      justify-content: center;
      margin-top: 4px;

      >span {
        text-decoration-line: underline;
      }
    }
  }
}

.van-tabbar-item--active {
  color: #6937E3;
}
</style>